import { useEffect, useState } from 'react'
import Storage from '../../lib/Storage'

const usePartnerName = () => {
  const getPartnerName = () => {
    const activeRole = Storage().getActiveRole()

    return activeRole?.type !== 'PUBLISHER'
      ? activeRole?.subname
      : activeRole?.name
  }

  const [partnerName, setPartnerName] = useState(getPartnerName())

  useEffect(() => {
    const updatePartnerName = () => setPartnerName(getPartnerName())

    window.addEventListener('storage', updatePartnerName)
    window.addEventListener('activeRoleChanged', updatePartnerName)

    return () => {
      window.removeEventListener('storage', updatePartnerName)
      window.removeEventListener('activeRoleChanged', updatePartnerName)
    }
  }, [])

  return partnerName
}

export default usePartnerName
